import React from "react";
import ReactDOM from "react-dom";
import App from "./components/App";
import registerServiceWorker from "./registerServiceWorker";
import Login from "./components/Auth/Login";
import Register from "./components/Auth/Register";
import firebase from "./firebase";
import "semantic-ui-css/semantic.min.css";
import { setUser, clearUser, setSelectChannel } from "./actions";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  withRouter
} from "react-router-dom";

import { createStore } from "redux";
import { Provider, connect } from "react-redux";
import { composeWithDevTools } from "redux-devtools-extension";
import rootReducer from "./reducers";
import Spinner from "./Spinner";
import md5 from "md5";

const store = createStore(rootReducer, composeWithDevTools());

class Root extends React.Component {
  state = {
    channelId: ""
  };

  saveUser = createdUser => {
    return firebase
      .database()
      .ref("users")
      .child(createdUser.user.uid)
      .set({
        name: createdUser.user.displayName,
        avatar: createdUser.user.photoURL,
        adminFlag: false
      });
  };

  componentDidMount() {
    //window.location.searchをURLSearchParamsに渡す
    var urlParams = new URLSearchParams(window.location.search);
    //idの値を取得する
    console.log("index.js" + urlParams.get("email"));
    console.log("index.js" + urlParams.get("pass"));
    console.log("index.js" + urlParams.get("id"));
    console.log("index.js" + urlParams.get("status"));

    console.log("index.js" + urlParams.get("channelId"));
    //this.setState({ channelId: urlParams.get("channelId") });
    this.props.setSelectChannel(urlParams.get("channelId"));

    //ハロリノからログイン
    urlParams.get("page") &&
      //urlParams.get("email") &&
      //urlParams.get("pass") &&
      urlParams.get("id") &&
      firebase
        .auth()
        .signInWithEmailAndPassword(
          urlParams.get("id").slice(0, 7) + "@enjoyworks.jp",
          urlParams.get("id").slice(7)
          //urlParams.get("email"),
          //urlParams.get("pass")
          // email,
          // password
        )
        .then(signedInUser => {
          console.log(signedInUser);
        })
        .catch(err => {
          console.error(err);
          this.setState({
            errors: this.state.errors.concat(err),
            loading: false
          });
        });

    urlParams.get("page") &&
      firebase.auth().onAuthStateChanged(user => {
        if (user) {
          this.props.setUser(user);
          this.props.history.push("/");
        }
      });

    !urlParams.get("page") &&
      firebase.auth().onAuthStateChanged(user => {
        if (user) {
          this.props.setUser(user);
          this.props.history.push("/");
        } else {
          this.props.history.push("/login");
          this.props.clearUser();
        }
      });
  }

  render() {
    //console.log(this.props.selectChannel);

    return this.props.isLoading ? (
      <Spinner />
    ) : (
      <Switch>
        <Route exact path="/" component={App} />
        <Route path="/login/" component={Login} />
        <Route path="/register" component={Register} />
      </Switch>
    );
  }
}

const mapStateFromProps = state => ({
  isLoading: state.user.isLoading,
  selectChannel: state.channel.selectChannel
});

const RootWithAuth = withRouter(
  connect(
    mapStateFromProps,
    { setUser, clearUser, setSelectChannel }
  )(Root)
);

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <RootWithAuth />
    </Router>
  </Provider>,
  document.getElementById("root")
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js